import { render, staticRenderFns } from "./dialogItemEdit.vue?vue&type=template&id=1a6f58c2&scoped=true"
import script from "./dialogItemEdit.vue?vue&type=script&lang=js"
export * from "./dialogItemEdit.vue?vue&type=script&lang=js"
import style0 from "./dialogItemEdit.vue?vue&type=style&index=0&id=1a6f58c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f58c2",
  null
  
)

export default component.exports